// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3mQlp","load3":"Loader_load3__1LZPN"};